import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';
import { usePeopleConfig } from '../PeopleConfigContext';
import { styles as configStyles } from '../PeopleHubConfiguration.styles';
import { DropdownSelect } from './DropdownSelect';

/**
 * Org and Department selectors shared by every tab except Change History.
 * The selection lives in PeopleConfigContext so it carries across tabs.
 */
const OrgDeptPicker: React.FC = () => {
  const { org, dept, orgDepts, setScope } = usePeopleConfig();
  const orgs = Array.from(new Set(orgDepts.map((x) => x.org)));
  const depts = orgDepts.filter((x) => x.org === org).map((x) => x.dept);

  return (
    <View style={styles.row}>
      <View style={styles.field}>
        <Text style={configStyles.formLabel}>Org</Text>
        <DropdownSelect
          value={org}
          onChange={(o) => setScope(o, orgDepts.find((x) => x.org === o)?.dept ?? '')}
          options={orgs.map((o) => ({ value: o, label: o }))}
          placeholder="Select org"
        />
      </View>
      <View style={styles.field}>
        <Text style={configStyles.formLabel}>Department</Text>
        <DropdownSelect
          value={dept}
          onChange={(d) => setScope(org, d)}
          options={depts.map((d) => ({ value: d, label: d }))}
          placeholder="Select department"
        />
      </View>
      <Text style={styles.note}>Orgs and departments come from Location Management.</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap' },
  field: { minWidth: 220 },
  note: {
    fontSize: 12,
    lineHeight: 18,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginBottom: 8,
  },
});

export default OrgDeptPicker;
